import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux'

import reducer from '@src/redux/reducer'
import errorReporter from './middleware/error-reporter'
import rootSaga from '@src/redux/sagas'
import createInitialState from './initialState'

export default function configureStore (history) {
  const sagaMiddleware = createSagaMiddleware()
  const middleware = compose(
    applyMiddleware(
      errorReporter,
      sagaMiddleware,
      routerMiddleware(history)
    )
  )

  const initialState = createInitialState()
  const store = createStore(reducer, initialState, middleware)

  syncHistoryWithStore(history, store)
  sagaMiddleware.run(rootSaga)

  return store
}



// WEBPACK FOOTER //
// ./src/redux/store/store.prod.js